import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { MANAGEMENT_CANCEL_TEXT } from "app/pages/sales-intelligence/pages/management/translations/managementKeys";

import { StyledFooterContent, StyledFooterWrapper } from "./styles";

type ExtensionSettingsFooterProps = {
    hasChanges: boolean;
    isSaving?: boolean;
    onCancel: () => void;
    onSave: () => void;
};

export const ExtensionSettingsFooter = ({
    hasChanges,
    isSaving = false,
    onCancel,
    onSave,
}: ExtensionSettingsFooterProps) => {
    const { translate } = useTranslate();

    return (
        <StyledFooterWrapper
            background={colorsPalettes.carbon[0]}
            borderTop={`1px solid ${colorsPalettes.carbon[100]}`}
            position="sticky"
            bottom="0"
            zIndex={1}
            data-automation="sales-intelligence-extension-settings-footer"
        >
            <StyledFooterContent
                width="100%"
                margin="0 auto"
                padding="16px 0"
                justifyContent="flex-end"
                gap="8px"
            >
                <Button
                    type="flat"
                    onClick={onCancel}
                    data-automation="sales-intelligence-extension-settings-cancel"
                >
                    {translate(MANAGEMENT_CANCEL_TEXT)}
                </Button>
                <Button
                    onClick={onSave}
                    isDisabled={!hasChanges || isSaving}
                    isLoading={isSaving}
                    data-automation="sales-intelligence-extension-settings-save"
                >
                    {translate("si.common.button.save")}
                </Button>
            </StyledFooterContent>
        </StyledFooterWrapper>
    );
};
